import React, { Component } from 'react';

import DesktopResponsive from './responsive/WebHosting/DesktopResponsive';
import MobileResponsive from './responsive/WebHosting/MobileResponsive';

class WebHosting extends Component {
  render() {
    return (
      <div>
        <DesktopResponsive history={this.props.history} />
        <MobileResponsive history={this.props.history} />
      </div>
    );
  }
}

export default WebHosting;
